import IdentificationError from './IdentificationError';
class PassportFileExtensionIsInvalid extends IdentificationError {
    constructor(options) {
        super('Passport file extension is invalid', options);
    }
}
export default PassportFileExtensionIsInvalid;
